<template>
  <badge :type="getBadgeType()">
    {{ $t(`ESTABLISHMENT_TRANSFERS.STATUS_${transfer.status}`) }}
  </badge>
</template>

<script>
import {
  ESTABLISHMENT_TRANSFER_STATUS_DRAFT,
  ESTABLISHMENT_TRANSFER_STATUS_SUBMITTED,
  ESTABLISHMENT_TRANSFER_STATUS_ACCEPTED,
  ESTABLISHMENT_TRANSFER_STATUS_REJECTED,
  ESTABLISHMENT_TRANSFER_STATUS_CANCELED,
} from "@/constants/establishmentTransfers";

export default {
  name: "establishment-transfer-status-badge",
  props: {
    transfer: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getBadgeType() {
      switch (this.transfer.status) {
        case ESTABLISHMENT_TRANSFER_STATUS_DRAFT:
          return "primary";
        case ESTABLISHMENT_TRANSFER_STATUS_SUBMITTED:
          return "info";
        case ESTABLISHMENT_TRANSFER_STATUS_ACCEPTED:
          return "success";
        case ESTABLISHMENT_TRANSFER_STATUS_REJECTED:
          return "warning";
        case ESTABLISHMENT_TRANSFER_STATUS_CANCELED:
          return "danger";
        default:
          return "default";
      }
    },
  },
};
</script>
